import { redirect } from "@tanstack/react-router";

import { getAuth } from "@/lib/auth-storage";

/** Admin pages. The same sign-in code is required before this token exists. */
export function requireAdmin() {
  if (typeof window === "undefined") return;
  const auth = getAuth();
  if (!auth?.token) throw redirect({ to: "/signin", replace: true });
  if (auth.user.role !== "ADMIN") throw redirect({ to: "/dashboard", replace: true });
}
